import React from 'react'
import { AdCreative, formatCallPhoneNumber, isCallCreative } from '@marketing-milk/interfaces'
import PhoneOutlined from '@mui/icons-material/PhoneOutlined'
import { Popover, Typography, Divider } from '@material-ui/core'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    popover: {
      pointerEvents: 'none',
    },
    paper: {
      padding: theme.spacing(1),
    },
  })
)

/** Marks a Call Now creative on the card, the way LeadCardIcon marks one carrying a lead form. */
export function CallCreativeIcon(props: { creative: AdCreative }) {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null)
  const open = Boolean(anchorEl)

  if (!isCallCreative(props.creative)) return <></>

  return (
    <>
      <div
        data-testid="call-creative-icon"
        className="flex h-8 w-8 items-center justify-center rounded-full bg-white shadow-sm"
        aria-label="Call Now ad"
        aria-owns={open ? 'call-creative-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={(event: React.MouseEvent<HTMLElement, MouseEvent>) =>
          setAnchorEl(event.currentTarget)
        }
        onMouseLeave={() => setAnchorEl(null)}
      >
        <PhoneOutlined fontSize="small" className="text-mm-neutral-1-700" />
      </div>
      <Popover
        id="call-creative-popover"
        className={classes.popover}
        classes={{ paper: classes.paper }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        onClose={() => setAnchorEl(null)}
        disableRestoreFocus
      >
        <Typography variant="subtitle1">Call Now</Typography>
        <Divider />
        <Typography className="mt-2" variant="h6">
          {formatCallPhoneNumber(props.creative.callPhoneNumber) ?? 'No number set'}
        </Typography>
      </Popover>
    </>
  )
}
